import type { MutationHookOptions } from '@apollo/client'
import {
  EditTrainingQueryDocument,
  UpdateTrainingRelatorioUnicoFieldDocument,
  UpdateTrainingRelatorioUnicoFieldMutation,
  UpdateTrainingRelatorioUnicoFieldMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  UpdateTrainingRelatorioUnicoFieldMutation,
  UpdateTrainingRelatorioUnicoFieldMutationVariables
>

export const useUpdateTrainingRelatorioUnicoField = (options?: Options) => {
  const [updateTrainingRelatorioUnicoField, { loading }] = useMutation(
    UpdateTrainingRelatorioUnicoFieldDocument,
    {
      ...options,
      extractorFn: (data) => data.trainingsMutations.updateTrainingsTrainingRelatorioUnicoField,
    }
  )

  return {
    loading,
    update(variables: UpdateTrainingRelatorioUnicoFieldMutationVariables) {
      return updateTrainingRelatorioUnicoField({
        variables,
        refetchQueries: [EditTrainingQueryDocument],
      })
    },
  }
}
